up.compiler('[row-collapse]', (element) => {
  element.addEventListener('click', function(evt) {
    if (evt.target.closest('.collapse-toggle')) {
      const targetClass = element.getAttribute('toggle-target')
      const targetElement = document.querySelector(targetClass)
      targetElement.closest('tr').classList.toggle('hidden')
      element.classList.toggle('collapsed')
    }
  })
})
